import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { MbNavigationService, NavigationNode } from '../../mb-navigation.service'
import { map } from 'rxjs/operators'
import { MediaQueries } from '../../../enums/media-queries'
import { ImageSize } from '../../../enums/image-size'

@Component({
  selector: 'mb-category-navigation-fourth-level',
  templateUrl: './mb-category-navigation-fourth-level.component.html',
  styleUrls: ['./mb-category-navigation-fourth-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationFourthLevelComponent {

  @Output() closeEvent = new EventEmitter<Event>()

  @Input() set isSubCategorySelected (isSubCategorySelected: boolean | null) {
    this.isSubCategorySelected$.next(!!isSubCategorySelected)
  }

  @Input() set activeSubCategory (activeSubCategory: NavigationNode | undefined | null) {
    this.activeSubCategory$.next(activeSubCategory)
  }

  isSubCategorySelected$ = new BehaviorSubject(false)
  activeSubCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  navigation$ = this.navigationService.navigation$

  areTeasersVisible$ = this.activeSubCategory$.pipe(
    map(activeSubCategory => activeSubCategory?.teasers?.some(teaser => teaser.isVisible) ?? false))

  state$ = combineLatest([
    this.navigationService.navigation$,
    this.isSubCategorySelected$,
    this.activeSubCategory$,
    this.areTeasersVisible$
  ]).pipe(
    map(([navigation, isSubCategorySelected, activeSubCategory, areTeasersVisible]) => ({
      navigation,
      isSubCategorySelected,
      activeSubCategory,
      areTeasersVisible
    } as MbCategoryNavigationFourthLevelState)))

  constructor (private navigationService: MbNavigationService) {
  }

  readonly mediaQuery = MediaQueries
  readonly imageSize = ImageSize
}

export interface MbCategoryNavigationFourthLevelState {
  navigation: NavigationNode[];
  isSubCategorySelected: boolean;
  activeSubCategory: NavigationNode | undefined | null;
  areTeasersVisible: boolean;
}
